import { render } from "./CampaignPeriodList.vue?vue&type=template&id=b945c19a&scoped=true"
import script from "./CampaignPeriodList.vue?vue&type=script&lang=js"
export * from "./CampaignPeriodList.vue?vue&type=script&lang=js"

import "./CampaignPeriodList.vue?vue&type=style&index=0&id=b945c19a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b945c19a"]])

export default __exports__